import { Select } from 'antd';
import { useCallback, useMemo } from 'react';
import { branchTypes } from '../store/StoreUtils';

interface BranchTypeSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void;
  onSelect?: (customer: any) => void;
}

const BranchTypeSelect: React.FC<BranchTypeSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  onChange,
  onSelect,
}) => {
  const changeHandler = useCallback(
    (value: string) => {
      const item = branchTypes.find((it: any) => it?.code === value);
      if (onChange) onChange(value);
      if (onSelect) onSelect(item);
    },
    [onSelect, onChange]
  );

  const options = useMemo(() => {
    return branchTypes.map((item: any) => {
      return {
        label: item.name,
        value: item.code,
      };
    });
  }, []);

  return (
    <Select
      placeholder="Хүргэлт сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      onChange={changeHandler}
      options={options}
      disabled={disabled}
      value={value}
      filterOption={false}
    />
  );
};

export default BranchTypeSelect;
